module.exports = __webpack_public_path__ + "static/media/techlead.f9424368.jpg";